var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrinterKo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "54px",
    viewBox: "0 0 51 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0660F243-8EA6-4ACD-8A5D-014EC902AB8D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Distribuer",
    transform: "translate(-1757.000000, -31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/printer-ko",
    transform: "translate(1759.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "11 14 11 0 37 0 37 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6839024,42 L0,42 L0,19.8057296 C0.0126079084,17.7001236 1.69746242,15.9999611 3.77146341,16 L43.2285366,16 C45.3025376,15.9999611 46.9873921,17.7001236 47,19.8057296 L47,42 L38.3160976,42",
    id: "Path",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.8037205,45.7554487 C38.2259797,47.1988498 38.2095238,49.5222398 36.766107,50.9436999 C36.0514511,51.6481612 35.1205178,52 34.1911517,52 C33.2429789,52 32.2955897,51.6348399 31.5777994,50.9060869 L24.5331105,43.7596058 L17.2447176,50.9436999 C16.5292781,51.6481612 15.5991284,52 14.6689787,52 C13.7215895,52 12.7742003,51.6348399 12.0556264,50.9060869 C10.6333672,49.4634694 10.6506067,47.1400794 12.0932398,45.7178356 L19.3816327,38.5337415 L12.1958933,31.2446442 C10.773634,29.8012431 10.7908735,27.4786367 12.2335067,26.0556094 C13.6761399,24.6341492 15.9995551,24.6498213 17.4218143,26.0932224 L24.6067702,33.3823197 L31.7556797,26.3361401 C33.1990965,24.9146799 35.5217281,24.9311356 36.9439874,26.3737531 C38.3662466,27.8163707 38.3497907,30.1397606 36.9071575,31.5620044 L29.7582479,38.608184 L36.8037205,45.7554487 Z",
    id: "Path",
    fill: "#F13F3D",
    fillRule: "nonzero"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrinterKo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/printer-ko.2d8459e58d99ec5d2cd188eab3e7acaa.svg";